import MissingIcon from '@images/icons/missing-content-icon.svg?react'
import './CoreMissingContent.scss'
import type { ReactNode } from 'react'

interface MissingContentProps {
  title?: string
  subTitle?: string
  description?: string
  CustomComponent?: ReactNode
  icon?: ReactNode
}

export const CoreMissingContent = ({ title, subTitle, description, icon, CustomComponent }: MissingContentProps) => {
  return (
    <div className='missing-content-wrapper'>
      {icon ? icon : <MissingIcon />}
      {title && <span className='title'>{title}</span>}
      {subTitle && <span className='sub-title'>{subTitle}</span>}
      {description && <span className='description'>{description}</span>}
      {CustomComponent}
    </div>
  )
}
